var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { api } from 'api';
import { useState, useEffect, useRef, useCallback } from 'react';
import { useNotification } from '../../notifications';
var decodeBase64PDF = function (base64String) {
    var cleanBase64String = base64String;
    if (cleanBase64String === null || cleanBase64String === void 0 ? void 0 : cleanBase64String.startsWith('data:')) {
        var commaIndex = cleanBase64String.indexOf(',');
        cleanBase64String = cleanBase64String.substring(commaIndex + 1);
    }
    // Decode Base64 string
    var byteCharacters = atob(cleanBase64String);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    // Create a Blob from the byte array
    var blob = new Blob([byteArray], { type: 'application/pdf' });
    // Create a URL for the Blob and trigger download
    return URL.createObjectURL(blob);
};
export var useGetPdf = function (offerId) {
    var liveNotification = useNotification().liveNotification;
    var _a = useState(null), data = _a[0], setData = _a[1];
    var _b = useState(''), fileName = _b[0], setFileName = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    var abortController = useRef(new AbortController());
    useEffect(function () {
        return function () {
            abortController.current.abort();
            setError(null);
            setData(null);
            setIsLoading(false);
        };
    }, []);
    var execute = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, file, error_1, errorMessage;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!offerId)
                        return [2 /*return*/];
                    setIsLoading(true);
                    setError(null);
                    abortController.current.abort();
                    abortController.current = new AbortController();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, api.utils.apiUtilsPrintIdGet(offerId, {
                            signal: abortController.current.signal
                        })];
                case 2:
                    response = _b.sent();
                    if (response.status !== 200) {
                        throw new Error('Error opening file');
                    }
                    // Assuming response.data has fileContents and fileDownloadName
                    if (response.data) {
                        file = decodeBase64PDF(
                        //@ts-ignore
                        response.data.fileContents);
                        //@ts-ignore
                        setFileName(response.data.fileDownloadName || "Offer-".concat(offerId, ".pdf"));
                        setData(file);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _b.sent();
                    errorMessage = 
                    //@ts-ignore
                    ((_a = error_1.response) === null || _a === void 0 ? void 0 : _a.data) || error_1.message || 'An unknown error occurred';
                    liveNotification('error', errorMessage);
                    setError(errorMessage);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [offerId]);
    return { data: data, fileName: fileName, isLoading: isLoading, error: error, execute: execute };
};
